import api from './api';

class OptionService {
    getPublic() {
        return api.get('/api/v1/options/public' );
    }
    getPrivate() {
        return api.get('/api/v1/options/private' );
    }
}
export default new OptionService();
